import {
  faCalendar,
  faMoneyBillWave,
  faPlusSquare,
  faUser,
  faUserPlus,
  faVolleyballBall,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import InternalRouter from "../components/elements/InternalRouter.Element";
import { InternalRoute } from "../interfaces/InternalRoute.Interface";
import AddGoalsAndAssistsComponent from "../internal/manage/AddGoalsAndAssists.Component";
import AddNewPlayerComponent from "../internal/manage/AddNewPlayer.Component";
import AttendanceComponent from "../internal/manage/Attendance.Component";
import CollectMoneyComponent from "../internal/manage/CollectMoney.Component";
import NewPlayerRequestsComponent from "../internal/manage/NewPlayerRequests.Component";
import PlayerListComponent from "../internal/manage/PlayerList.Component";
import { ROUTES } from "../routes";
import "./Manage.Styles.scss";

export default function ManageScreen() {
  const routes: InternalRoute[] = [
    {
      icon: faCalendar,
      route: ROUTES.attendance,
      title: "Attendance",
      component: AttendanceComponent,
    },
    {
      icon: faVolleyballBall,
      route: ROUTES.addGoalsAndAssists,
      title: "Add Goals and Assists",
      component: AddGoalsAndAssistsComponent,
    },
    {
      icon: faMoneyBillWave,
      route: ROUTES.collectMoney,
      title: "Collect Money",
      component: CollectMoneyComponent,
    },

    {
      icon: faUser,
      route: ROUTES.players,
      title: "Players",
      component: PlayerListComponent,
    },
    {
      icon: faPlusSquare,
      route: ROUTES.addPlayer,
      title: "Add Player",
      component: AddNewPlayerComponent,
    },
    {
      icon: faUserPlus,
      route: ROUTES.newPlayerRequests,
      title: "New Player Requests",
      component: NewPlayerRequestsComponent,
    },
  ];
  return (
    <div className="manageteam-container">
      <InternalRouter internalRoutes={routes} />
    </div>
  );
}
